import { getDbSupabase } from './supabase';
import { formatSupabaseError } from './formatSupabaseError';
import type { AccountTransferOptions } from './accountTransferScope';

export async function submitAccountTransfer(
  clientId: string,
  toOwnerId: string,
  options: AccountTransferOptions = {},
): Promise<string> {
  const { data, error } = await getDbSupabase().rpc('submit_account_transfer', {
    p_client_id: Number(clientId),
    p_to_owner_id: toOwnerId,
    p_message: options.message?.trim() || null,
    p_include_sub_companies: options.includeSubCompanies ?? false,
    p_include_projects: options.includeProjects ?? false,
    p_include_tasks: options.includeTasks ?? false,
  });
  if (error) throw new Error(formatSupabaseError(error));
  return String(data);
}

export async function approveAccountTransfer(requestId: string): Promise<void> {
  const { error } = await getDbSupabase().rpc('approve_account_transfer', {
    p_request_id: requestId,
  });
  if (error) throw new Error(formatSupabaseError(error));
}

export async function rejectAccountTransfer(
  requestId: string,
  reviewNote?: string,
): Promise<void> {
  const { error } = await getDbSupabase().rpc('reject_account_transfer', {
    p_request_id: requestId,
    p_review_note: reviewNote?.trim() || null,
  });
  if (error) throw new Error(formatSupabaseError(error));
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  const { error } = await getDbSupabase()
    .from('crm_notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('id', notificationId);
  if (error) throw new Error(formatSupabaseError(error));
}

export async function markAllNotificationsRead(userId: string): Promise<void> {
  const { error } = await getDbSupabase()
    .from('crm_notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('user_id', userId)
    .is('read_at', null);
  if (error) throw new Error(formatSupabaseError(error));
}
